import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, BookOpen, Heart } from 'lucide-react';
export function BonusSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const bonuses = [{
    icon: <Target className="w-5 h-5 text-white" data-id="element-37" />,
    title: 'Kit de Productividad Digital',
    value: '$19.000',
    color: '#00A3FF' // Azul claro
  }, {
    icon: <BookOpen className="w-5 h-5 text-white" data-id="element-38" />,
    title: 'Técnicas de Concentración y Enfoque',
    value: '$15.000',
    color: '#9D4EDD' // Morado
  }, {
    icon: <Heart className="w-5 h-5 text-white" data-id="element-39" />,
    title: 'Bienestar Universitario',
    value: '$12.000',
    color: '#00C853' // Verde
  }];
  return <section className="w-full py-24 px-4 relative overflow-hidden bg-transparent" data-id="element-40">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-gradPink/5 blur-[120px] rounded-full pointer-events-none" data-id="element-41" />

      <div className="max-w-2xl mx-auto flex flex-col items-center relative z-10" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black text-white mb-4 text-center leading-tight flex items-center justify-center gap-4" data-id="element-43">
          <BookOpen className="w-10 h-10 text-white" data-id="element-44" />
          Más los 3 Bonos Estratégicos
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex items-center gap-3 bg-white/5 border border-white/10 px-6 py-3 rounded-full mb-16" data-id="element-45">
          <span className="text-xl" data-id="element-46">🎁</span>
          <span className="text-lg md:text-xl text-transparent bg-clip-text bg-gradient-to-r from-[#00C853] to-[#00E676] font-bold" data-id="element-47">
            Bonos gratis solo por hoy
          </span>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="flex flex-col gap-3 w-full" data-id="element-48">
          {bonuses.map((bonus, index) => <motion.div key={index} variants={itemVariants} className="group relative bg-[#130F1C] rounded-xl p-4 md:p-5 border border-white/5 overflow-hidden w-full flex flex-col items-center text-center transition-all duration-500 hover:-translate-y-1" data-id="element-49">
              {/* Borde iluminado en hover */}
              <div className="absolute inset-0 rounded-xl border-2 border-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
            borderColor: bonus.color,
            boxShadow: `inset 0 0 20px ${bonus.color}40`
          }} data-id="element-50" />

              {/* Resplandor inferior */}
              <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 w-[80%] h-[60px] blur-[40px] opacity-30 group-hover:opacity-70 group-hover:h-[100px] transition-all duration-500 pointer-events-none" style={{
            backgroundColor: bonus.color
          }} data-id="element-51" />

              <div className="relative z-10 w-full flex flex-col items-center" data-id="element-52">
                <div className="w-full flex justify-between items-center mb-3" data-id="element-53">
                  {/* Icono */}
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center shadow-lg" style={{
                backgroundColor: bonus.color
              }} data-id="element-54">
                    {bonus.icon}
                  </div>

                  {/* Pill */}
                  <div className="px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-black text-white/80 tracking-widest uppercase" data-id="element-55">
                    BONO {index + 1}
                  </div>
                </div>

                {/* Título */}
                <h3 className="text-lg md:text-xl font-black text-white tracking-tight mb-2 w-full text-center" data-id="element-56">
                  {bonus.title}
                </h3>

                <span className="text-white/50 text-sm font-medium mb-3" data-id="element-57">
                  Valor normal:{' '}
                  <span className="line-through" data-id="element-58">{bonus.value}</span>
                </span>

                <div className="bg-[#00C853] text-white font-black text-base px-8 py-2.5 rounded-full w-full max-w-[200px] shadow-[0_0_20px_rgba(0,200,83,0.4)]" data-id="element-59">
                  GRATIS
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Badge resumen de bonos */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-8 w-full bg-[#00C853]/10 border border-[#00C853]/30 rounded-2xl px-6 py-4 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-center shadow-[0_0_25px_rgba(0,200,83,0.15)]" data-id="element-60">
          <span className="text-white font-bold text-sm md:text-base" data-id="element-61">
            Valor total de bonos:{' '}
            <span className="text-white/50 line-through" data-id="element-62">$47.000</span>
          </span>
          <span className="text-[#00C853] font-black text-base md:text-lg" data-id="element-63">
            🎁 GRATIS
          </span>
          <span className="text-textMuted text-xs md:text-sm font-medium" data-id="element-64">
            ¡Incluidos siempre en todas las ofertas!
          </span>
        </motion.div>
      </div>
    </section>;
}